import { Col, ColType, Crud } from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";

import { Form, Modal, Typography } from "@douyinfe/semi-ui";
import { formatFloat, formatDate } from "../../utils";
import { useState, useEffect } from "react";

const apiClient = ApiClient.getDefault();
export default function AgainAssignStarStat() {
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");
  let cols: Col[] = [
    {
      name: "名称",
      width: 180,
      showInFilter: false,
      key: "name",
      type: ColType.STRING,
      render: (value, record, index) => {
        if (record.type == "org") {
          return (
            <Typography.Text strong type="warning">
              {value}
            </Typography.Text>
          );
        } else {
          return <Typography.Text strong>{value}</Typography.Text>;
        }
      },
    },

    {
      name: "再分配总数",
      width: 100,
      key: "totalCount",
      type: ColType.NUMBER,
    },
    {
      name: "已拨打数",
      width: 100,
      key: "contactCount",
      type: ColType.NUMBER,
    },
    {
      name: "0星",
      width: 80,
      key: "star0",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <span>
            <Typography.Text>{value}</Typography.Text>/
            <Typography.Text type="danger">
              {record.starContact0}
            </Typography.Text>
          </span>
        );
      },
    },
    {
      name: "1星",
      width: 80,
      key: "star1",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <span>
            <Typography.Text>{value}</Typography.Text>/
            <Typography.Text type="danger">
              {record.starContact1}
            </Typography.Text>
          </span>
        );
      },
    },
    {
      name: "2星",
      width: 80,
      key: "star2",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <span>
            <Typography.Text>{value}</Typography.Text>/
            <Typography.Text type="danger">
              {record.starContact2}
            </Typography.Text>
          </span>
        );
      },
    },
    {
      name: "3星",
      width: 80,
      key: "star3",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <span>
            <Typography.Text>{value}</Typography.Text>/
            <Typography.Text type="danger">
              {record.starContact3}
            </Typography.Text>
          </span>
        );
      },
    },
    {
      name: "4星",
      width: 80,
      key: "star4",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <span>
            <Typography.Text>{value}</Typography.Text>/
            <Typography.Text type="danger">
              {record.starContact4}
            </Typography.Text>
          </span>
        );
      },
    },

    {
      name: "5星",
      width: 80,
      key: "star5",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <span>
            <Typography.Text>{value}</Typography.Text>/
            <Typography.Text type="danger">
              {record.starContact5}
            </Typography.Text>
          </span>
        );
      },
    },

    {
      name: "城市",
      key: "city",
      colSort: 2,
      hideInList: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "销售",
      key: "saleIds",
      colSort: 3,
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.TREE_MUL,
      getOptions: () => {
        if(role == "op_manager" || role == "monitor"){
          return apiClient.getTeamMemberTreeAsOpts("root");
        }else{
          return apiClient.getTeamMemberTreeAsOpts(username);
        }
      }
    },
    {
      name: "日期",
      key: "createdAt",
      hideInList: true,
      showInFilter: true,
      type: ColType.DATE_RANGE,
    },
    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },
  ];

  let nowDate = new Date();
  let nowDateStr = formatDate(nowDate);
  const [initFilterValues, setInitFilterValues] = useState({
    createdAt: [nowDate, nowDate],
  });

  const initParams = {
    createdAt: nowDateStr + "," + nowDateStr,
  };

  return (
    <>
      <Crud
        name="再分配客户跟进报表"
        initFilterValues={initFilterValues}
        params={initParams}
        entityKey="statAgainAssignStar"
        pageSize={500}
        rowActionWidth={0}
        cols={cols}
      />
    </>
  );
}
